import { Button, TextField } from '@mui/material'
import Grid from '@mui/material/Grid'
import React from 'react'
import { Person } from '../../../../generated/graphql'

export type ComponentProps = {
    person: Person
    submit: (person: Person) => void
}

const PersonForm = ({ person, submit }: ComponentProps) => {
    const [updatedPerson, setUpdatedPerson] = React.useState<Person>(person)

    const handlePersonChange = React.useCallback(
        (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
            setUpdatedPerson({
                ...updatedPerson,
                [e.target.name]: e.target.value,
            })
        },
        [updatedPerson, setUpdatedPerson]
    )

    return (
        <Grid
            container
            gap={3}
            flexDirection={'column'}
            component="form"
            onSubmit={() => submit(updatedPerson)}
        >
            <TextField
                fullWidth
                value={updatedPerson.name}
                label="Name"
                type="text"
                name="name"
                onChange={(e) => handlePersonChange(e)}
            />

            <TextField
                fullWidth
                value={updatedPerson.surname}
                label="Surname"
                type="text"
                name="surname"
                onChange={(e) => handlePersonChange(e)}
            />

            <TextField
                fullWidth
                value={updatedPerson.email}
                label="Email"
                type="email"
                name="email"
                onChange={(e) => handlePersonChange(e)}
            />

            <TextField
                fullWidth
                value={updatedPerson.phone}
                label="Phone"
                type="phone"
                name="phone"
                onChange={(e) => handlePersonChange(e)}
            />

            <TextField
                fullWidth
                value={updatedPerson.dni}
                label="DNI"
                type="text"
                name="dni"
                onChange={(e) => handlePersonChange(e)}
            />

            <Button variant="contained" color="primary" type="submit">
                Submit
            </Button>
        </Grid>
    )
}

export default React.memo(PersonForm)
